import React from "react";

export const NavList = ({ children }) =>
  <ul className="sidebar-nav">
    {children}
  </ul>;